import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AppControllerService } from "../../app-controller.service";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiModuleConstants } from "../../shared/constants/api-constants/api-module.constants";
import { ApiPropertyValuationprojectCycleConstants } from "../../shared/constants/api-constants/api-property-valuation-project-cycle.constants";
import { ApiEhActionTypeSurveyConstants } from "../../shared/constants/api-constants/api-eh-action-type-survey.constants";
import { ApiEhPremiseTypeSurveyConstants } from "../../shared/constants/api-constants/api-eh-premise-type-survey.constants";
import { map } from "rxjs/operators";
import { ApiLookupConstants } from "../../shared/constants/api-constants/api-lookup.constants";
import { ApiAvailableSurveyConstants } from "../../shared/constants/api-constants/api-available-survey.constants";
import { ApiModuleNotificationTemplateConstants } from "../../shared/constants/api-constants/api-module-notification-template.constants";
import { ApiOrganisationNotificationTemplateConstants } from "../../shared/constants/api-constants/api-organisation-notification-template.constants";
import { ApiUserConstants } from "../../shared/constants/api-constants/api-user.constants";
import { ApiApplicationConstants } from "../../shared/constants/api-constants/api-application.constants";
import { ApiPropertyValuationValuationRollConstants } from "../../shared/constants/api-constants/api-property-valuation-valuation-roll.constants";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { ApiAttachmentConstants } from "src/app/shared/constants/api-constants/api-attachment.constants";
let SettingsService = class SettingsService {
    http;
    userInformationService;
    appControllerService;
    selectedModule = null;
    $adminModules;
    systemModulesSubscription;
    constructor(http, userInformationService, appControllerService) {
        this.http = http;
        this.userInformationService = userInformationService;
        this.appControllerService = appControllerService;
        this.$adminModules = userInformationService.$adminModules;
        this.listenForSystemModules();
    }
    getRequest() {
        const request = this.appControllerService.getRequest(false, false);
        request.systemModuleID = this.selectedModule !== null ? this.selectedModule.id : null;
        return request;
    }
    backupSettingsObservable(moduleId, selectedSettings) {
        let queryParams = new HttpParams();
        queryParams = queryParams.append("lookups", selectedSettings.includes("Lookups"))
            .append("moduleRoles", selectedSettings.includes("Module roles"))
            .append("availableSurvey123s", selectedSettings.includes("Available survey123s"))
            .append("mapServices", selectedSettings.includes("Map services"))
            .append("nonWorkingDays", selectedSettings.includes("Non-working days"))
            .append("searchOptions", selectedSettings.includes("Search options"))
            .append("templates", selectedSettings.includes("Templates"))
            .append("notificationTemplates", selectedSettings.includes("Notification templates"))
            .append("recipients", selectedSettings.includes("Recipients"))
            .append("reports", selectedSettings.includes("Reports"))
            .append("stepMetadata", selectedSettings.includes("Step metadata"))
            .append("invoiceTemplates", selectedSettings.includes("Invoice templates"))
            .append("stampTemplates", selectedSettings.includes("Stamps"))
            .append("recipientGroups", selectedSettings.includes("Recipient groups"));
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_BACKUP_SETTINGS}`, { params: queryParams, responseType: "blob" });
    }
    backupModuleSettingsObservable(moduleId, selectedSettings) {
        return this.http.post(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_BACKUP_MODULE_SETTINGS}`, selectedSettings, { responseType: "blob" });
    }
    restoreSettingsObservable(data, moduleId) {
        return this.http.post(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_RESTORE_SETTINGS}`, data);
    }
    deleteprojectCycle(id) {
        return this.http.delete(`${ApiPropertyValuationprojectCycleConstants.URL}/${id}`);
    }
    getAttachmentContentObservable(attachmentId) {
        return this.http.get(`${ApiAttachmentConstants.URL}/${attachmentId}/${ApiAttachmentConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    deleteMultipleprojectCycle(params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleConstants.URL}/${ApiPropertyValuationprojectCycleConstants.FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUNS}`, params).pipe(map((response) => {
            return response.value;
        }));
    }
    getprojectCyclesToRefactor(moduleId, tableItems) {
        const params = {
            $expand: "parameters, pvProjectCycleAttachmentLinks, pvProjectCycleAttachmentLinks($expand=attachment)",
            $filter: "moduleId eq " + moduleId,
            $orderby: "fromDate"
        };
        return this.http.get(ApiPropertyValuationprojectCycleConstants.URL, { params }).pipe(map((response) => {
            Object.keys(response.value).forEach((element) => {
                if (!response.value[element].deleted) {
                    tableItems.push(response.value[element]);
                }
            });
            return response.value;
        }));
    }
    saveprojectCycles(params) {
        return this.http.post(ApiPropertyValuationprojectCycleConstants.URL, params);
    }
    saveProjectCyclesAttachment(id, params) {
        return this.http.post(`${ApiPropertyValuationprojectCycleConstants.URL}/${id}/${ApiPropertyValuationprojectCycleConstants.FUNCTION_SAVE_PROJECT_CYCLE_ATTACHMENT}`, params);
    }
    patchprojectCycles(projectCycleID, params) {
        return this.http.patch(`${ApiPropertyValuationprojectCycleConstants.URL}/${projectCycleID}`, params);
    }
    getModuleNotificationTemplatesObservable(params) {
        return this.http.get(`${ApiModuleNotificationTemplateConstants.URL}`, { params });
    }
    patchModuleNotificationTemplatesObservable(id, params) {
        return this.http.patch(`${ApiModuleNotificationTemplateConstants.URL}/${id}`, params);
    }
    getOrganisationNotificationTemplatesObservable(params) {
        return this.http.get(`${ApiOrganisationNotificationTemplateConstants.URL}`, { params });
    }
    patchOrganisationNotificationTemplatesObservable(id, params) {
        return this.http.patch(`${ApiOrganisationNotificationTemplateConstants.URL}/${id}`, params);
    }
    getLookupsObservable(params) {
        return this.http.get(`${ApiLookupConstants.URL}`, { params });
    }
    getLookupsUpdateObservable(lookupId, params) {
        return this.http.patch(`${ApiLookupConstants.URL}/${lookupId}`, params);
    }
    getAvailableSurveys(moduleId) {
        const params = {
            $select: "id,name,disabled",
            $filter: `moduleId eq ${moduleId} and deleted eq false`
        };
        return this.http.get(`${ApiAvailableSurveyConstants.URL}`, { params }).pipe(map(response => {
            return response.value;
        }));
    }
    getEhActionSurveys(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} and deleted eq false`,
            $expand: "survey"
        };
        return this.http.get(`${ApiEhActionTypeSurveyConstants.URL}`, { params }).pipe(map(response => {
            return response.value;
        }));
    }
    getEhPremiseSurveys(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} and deleted eq false`,
            $expand: "availableSurvey123"
        };
        return this.http.get(`${ApiEhPremiseTypeSurveyConstants.URL}`, { params }).pipe(map(response => {
            return response.value;
        }));
    }
    getEhPremiseTypesLookupsObservable(moduleId) {
        const params = {
            $select: "content",
            $filter: `name eq 'PremisesType' and moduleId eq ${moduleId} and deleted eq false`
        };
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map((response) => {
            return response.value;
        }));
    }
    saveEhLinkedPremiseSurvey(params) {
        return this.http.post(ApiEhPremiseTypeSurveyConstants.URL, params);
    }
    saveEhLinkedActionSurvey(params) {
        return this.http.post(ApiEhActionTypeSurveyConstants.URL, params);
    }
    patchEhLinkedActionSurvey(surveyLinkId, params) {
        return this.http.patch(`${ApiEhActionTypeSurveyConstants.URL}/${surveyLinkId}`, params);
    }
    patchEhLinkedPremiseSurvey(surveyLinkId, params) {
        return this.http.patch(`${ApiEhPremiseTypeSurveyConstants.URL}/${surveyLinkId}`, params);
    }
    removeEhLinkedActionSurvey(id) {
        return this.http.delete(`${ApiEhActionTypeSurveyConstants.URL}/${id}`).pipe(map((response) => {
            return response.value;
        }));
    }
    removeEhLinkedPremiseSurvey(id) {
        return this.http.delete(`${ApiEhPremiseTypeSurveyConstants.URL}/${id}`).pipe(map((response) => {
            return response.value;
        }));
    }
    listenForSystemModules() {
        this.systemModulesSubscription = this.userInformationService.$systemModules
            .subscribe(items => {
            for (const item of items) {
                const id = +this.appControllerService.selectedModuleID;
                if (item.id === id) {
                    this.selectedModule = item;
                }
            }
        });
    }
    getOriginalPortalUsers(moduleId) {
        return this.http.get(`${ApiUserConstants.URL}/${ApiUserConstants.FUNCTION_GET_PORTAL_USERS_WITH_APPLICATIONS}?moduleId=${moduleId}`);
    }
    getAllPortalUsers(moduleId) {
        return this.http.get(`${ApiUserConstants.URL}/${ApiUserConstants.FUNCTION_GET_PORTAL_USERS}?moduleId=${moduleId}`);
    }
    postChangeOwner(params) {
        return this.http.post(`${ApiApplicationConstants.URL}/${ApiApplicationConstants.FUNCTION_CHANGE_OWNER}`, params);
    }
    getprojectCycles(params) {
        return this.http.get(`${ApiPropertyValuationprojectCycleConstants.URL}`, { params });
    }
    getValuationRolls(params) {
        return this.http.get(`${ApiPropertyValuationValuationRollConstants.URL}`, { params });
    }
    saveValuationRoll(params) {
        return this.http.post(ApiPropertyValuationValuationRollConstants.URL, params);
    }
    patchValuationRoll(valuationRollId, params) {
        return this.http.patch(`${ApiPropertyValuationValuationRollConstants.URL}/${valuationRollId}`, params);
    }
    deleteValuationRolls(ids) {
        return this.http.post(`${ApiPropertyValuationValuationRollConstants.URL}/${ApiPropertyValuationValuationRollConstants.FUNCTION_DELETE_MULTIPLE_VALUATION_ROLLS}`, { ids });
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: UserInformationService },
        { type: AppControllerService }
    ];
};
SettingsService = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], SettingsService);
export { SettingsService };
